<template>
  <div class="point-page">
    <div class="point-page__inner">
      <div class="point-page__header">
        <button @click="$router.push(`/path/${this.getRouteID}/points`)"
          class="paths-page__action--absolute button--default">
          &lt; Назад
        </button>
      </div>

      <wrapper class="point-page__content">
        <router-view v-bind="{ point }" />
      </wrapper>

      <div class="point-page__actions">
        <button v-if="compareVersions()" @click="sharePointLink"
          class="point-page__action--small button button--positive button--center-no-icon">
          Поделиться
        </button>
        <div v-if="point.is_virtual">
          <button v-if="$route.name === 'point'" @click="completeVirtualPoint()" :disabled="point.pivot.is_finished"
            class="button button--positive point-page__action--small button--center-no-icon">
            <span>Я здесь</span>
          </button>
        </div>
        <div v-else>
          <button v-if="$route.name === 'point'"
            @click="$router.replace({ path: `/path/${getRouteID}/point/${point.id}/scan` })"
            :disabled="point.pivot?.is_finished"
            class="point-page__action--small button button--positive button--center-no-icon">
            Сканировать
          </button>
        </div>
      </div>
    </div>
    <modal-warn :message="error" dismissButtonValue="Закрыть" :isModalVisible="error"
      @modal-dismissed="dismissError"></modal-warn>
    <modal-success dismissButtonValue="Назад" :isModalVisible="isSuccess" @modal-dismissed="dismissSuccessModal">
      <p class="success-modal__text">Вы успешно прошли точку!</p>
      <div class="success-modal__image">
        <img :src="require('../assets/images/success_result.svg')" alt="" />
      </div>
    </modal-success>
    <modal-key-word :isModalVisible="viewKeyWordModal" :passPointByKeyWord="passPointByKeyWord" @modal-dismissed="dismissViewKeyWord" />
    <div id="modals"></div>
  </div>
</template>

<script>
import Wrapper from "@/components/Wrapper.vue";
import ModalWarn from "@/components/shared/components/modals/ModalWarn.vue";
import ModalSuccess from "@/components/shared/components/modals/ModalSuccess.vue";
import ModalKeyWord from "@/components/shared/components/modals/ModalKeyWord.vue";
import { mapActions, mapMutations } from "vuex";

export default {
  name: "PointPage",

  data: () => ({
    point: {},
    error: "",
    isSuccess: false,
    viewKeyWordModal: false,
    attemptPass: 0,
  }),

  components: {
    Wrapper,
    ModalWarn,
    ModalSuccess,
    ModalKeyWord
  },

  methods: {
    async init() {
      await this.fetchData();
      // this.handleShareNavigation();
    },

    ...mapMutations(["setLoader"]),
    ...mapActions(["getCurrentGeolocation", "postScanVirtualPoint", "passVirtualPointByKeyword"]),

    async fetchData() {
      const { commit, dispatch } = this.$store;
      try {
        commit("setLoader", true);
        const response = await dispatch("fetchPoint", {
          waypoint_id: Number(this.$route.params.id),
          route_id: this.getRouteID,
        });
        commit("setLoader", false);

        this.point = response.data.data;
      } catch (e) {
        commit("setLoader", false);
        console.warn("Error:", e);
      }
    },

    async completeVirtualPoint() {
      this.setLoader(true);

      try {
        const user_position = await this.getCurrentGeolocation();

        const response = await this.postScanVirtualPoint({
          route_id: this.getRouteID,
          waypoint_id: this.point.id,
          user_position,
        });

        if (!response.success) {
          throw new Error(response.message);
        }

        this.isSuccess = true;
      } catch (e) {

        if (this.attemptPass >= 1 && this.point?.keyword != null) {
          this.viewKeyWordModal = true;
          this.attemptPass = 0
        } else {
          if(this.point?.keyword != null) {
            this.attemptPass += 1
          }
          this.error = e.message;
        }
      } finally {
        this.setLoader(false);
      }
    },

    async passPointByKeyWord(keyWord) {
      this.setLoader(true);
      console.log(this.$store.state)
      try {
        const response = await this.passVirtualPointByKeyword({
          route_id: this.getRouteID,
          waypoint_id: this.point.id,
          keyword: keyWord
        });
        if (!response.status) {
          throw new Error(response.message);
        }
        this.isSuccess = true;
      } catch (error) {
        this.error = error.message;
      } finally {
        this.setLoader(false);
      }
    },

    dismissError() {
      this.error = "";
    },

    dismissViewKeyWord() {
      this.viewKeyWordModal = false;
    },

    dismissSuccessModal() {
      this.isSuccess = false;
      this.$nextTick(() => {
        this.$router.back();
      });
    },
    sharePointLink() {
      const idPath = this.getRouteID;
      const idPoint = this.point.id;
      if (!idPath || !idPoint) return;
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          action: 'shareRoute',
          idPath,
          idPoint
        })
      );
    },

    // handleShareNavigation() {
    //   const token = this.$route.query['token'];
    //   const pointId = this.point.id;
    //   const pathId = this.getRouteID;
    //   if (token) {
    //     this.simulateNavigation(pathId, pointId);
    //   }
    // },

    // async simulateNavigation(pathId, pointId) {
    //
    //   try {
    // await this.$router.push({ name: 'profile' });
    // await this.$router.push({ name: 'paths' });
    // await this.$router.push({ name: 'selectedPath', params: { id: pathId } });
    // await this.$router.push({ name: 'routePoints', params: { id: pointId } });
    // await this.$router.push({ path: `/path/${pathId}/point/${pointId}` });
    //     alert('aaaa')
    //   } catch (error) {
    //     console.error("Error simulating navigation:", error);
    //   }
    // },
    compareVersions() {
      const minVersion = "2.1.4";
      const version = window.appVersion || "0.0.0";
      console.log(`minRequiredVersion: ${minVersion}, appVersion: ${version}`);
      const v = version.split('.').map(Number);
      const minV = minVersion.split('.').map(Number);
      for (let i = 0; i < 3; i++) {
        if (v[i] > minV[i]) return true;
        if (v[i] < minV[i]) return false;
      }
      return true;
    }
  },

  computed: {
    getRouteID() {
      return Number(this.$route.path.match(/path\/(\d+)\//)[1]);
    },

    getScanResult() {
      return this.$store.getters.scan;
    },
  },

  created() {
    this.init();
  },
};
</script>

<style lang="scss">
.point-page {
  position: relative;
  height: 100vh;

  &__action--absolute {
    margin: 0 auto;
    width: 159px !important;
  }

  &__inner {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding-top: 139px;
  }

  &__header {
    padding: 100px 17px 0;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    max-height: 139px;
    background-color: #fff;
    z-index: 10;
  }

  &__actions {
    position: fixed;
    bottom: 56px;
    left: 0;
    width: 100%;
    padding: 0 35px;
    z-index: 10;

    align-items: center;
    justify-content: center;
    display: flex;
    gap: 10px;
  }

  &__action {
    width: 123px !important;
    margin: 0 auto;
  }

  &__action--small {
    width: 168px !important;
    padding: 10px 5px 10px 15px !important;
    font-size: 16px !important;
    font-weight: 700 !important;
    line-height: 19px !important;

    span {
      color: inherit;
      width: 100%;
      text-align: center;
    }
  }

  .success-modal {
    &__text {
      line-height: 40px;
      text-align: center;
      font-size: 16px;
      font-weight: 700;
      margin-bottom: 1rem;
    }

    &__image {
      margin-bottom: 1rem;
      border-radius: 50%;

      img {
        position: relative;
        scale: 0.75;
      }
    }
  }
}
</style>
